export class BiowebSpeciesSearchCriteria {
  nameCriteria: string;
  pageNumber = 1;
  pageSize = 10;
}
